import angular from 'angular';
import { RealEstateSearchResultListComponent } from './real-estate-search-result-list.component';
import SearchManager from './../../search/searches-manager/search-manager.module';
import loginService from './../../../frame/header/login/login.module';
import realEstateSearchResultItem from './../real-estate-search-result-item/real-estate-search-result-item.module';
import SearchService from './../../search/search.module';

const MODULE_NAME = 'realEstateSearchResultList';

export default angular.module(MODULE_NAME, [realEstateSearchResultItem, SearchManager, loginService, SearchService])
	.component('realEstateSearchResultList', RealEstateSearchResultListComponent).name;


